<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", ["information", "use_my_products"])
  },

  methods: {
    ...mapActions("newPurchase", ["setInformation", "setUseMyProducts"])
  }
};
</script>

<template>
  <div id="informations" class="section">
    <div class="section-title">INFORMAÇÕES SOBRE A LIMPEZA
      <hr>
    </div>

    <div class="section-body">
      <textarea
        name="description"
        rows="5"
        :value="information"
        @input="setInformation($event.target.value)"
      ></textarea>

      <div
        class="radio-product"
        :class="{'checked': use_my_products}"
        @click="setUseMyProducts(!use_my_products)"
      >Desejo usar os produtos que tenho em casa.</div>
      <div
        v-show="!use_my_products"
        class="quote"
      >ao marcar esta opção, o profissional não levará os produtos.</div>
    </div>
  </div>
</template>

<style scoped>
.section-body {
  width: 500px;
}

.radio-product {
  margin: 10px 0 0 20px;
  text-align: left;
  color: var(--pink);
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}

.radio-product::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border: 2px solid var(--pink);
  border-radius: 100%;
  margin-right: 5px;
  transition: all 0.25s ease;
}

.radio-product.checked::before {
  background-size: 1px 1px;
  background-color: var(--pink);
}

.quote {
  margin-top: 10px;
  margin-left: 30px;
  text-align: left;
  border-left: 1px solid var(--pink);
  padding: 5px 10px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Informations.vue